// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import { Button, Select, Option, Message, Dropdown, DropdownMenu, DropdownItem, ColorPicker, Tree, Dialog, Input, Form, FormItem, Table, TableColumn, Row, Col, Breadcrumb, BreadcrumbItem, Loading, Checkbox, CheckboxGroup, Tabs, TabPane, Transfer, Pagination, InputNumber, Switch, Upload, Menu, Submenu, MenuItem, MenuItemGroup, Steps, Step, RadioGroup, Radio, RadioButton, MessageBox, DatePicker, Tooltip, Autocomplete, Popover, Notification, Card, } from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import $ from 'jquery'
import router from './router'
import '../static/icon/iconfont.css'
import "babel-polyfill"

Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(ColorPicker)
Vue.use(Tree)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Row)
Vue.use(Col)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Transfer)
Vue.use(Pagination)
Vue.use(InputNumber)
Vue.use(Switch)
Vue.use(Upload)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Steps)
Vue.use(Step)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Loading.directive)
Vue.use(DatePicker)
Vue.use(Tooltip)
Vue.use(Autocomplete)
Vue.use(Popover);
Vue.use(Card);
Vue.use(RadioButton);


Vue.prototype.$message = Message;
Vue.prototype.$messageBox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$loading = Loading.service;
Vue.prototype.$notify = Notification;
// Vue.prototype.$axios = axios;

const setCacheData = (key, value) => {
    try {
        if (!localStorage) {
            console.warn('运行环境不支持localStorage，无法启用数据缓存功能！')
        } else if (key) {
            if (typeof value === 'string') {
                localStorage.setItem(key, value)
            } else {
                localStorage.setItem(key, JSON.stringify(value))
            }
        } else {
            console.warn('缓存键值不存在！')
        }
    } catch (error) {
        console.error('设置缓存失败：', error)
    }
}
Vue.prototype.$setCacheData = setCacheData

const getCacheData = (key) => {
    if (!localStorage) {
        console.warn('运行环境不支持localStorage，无法启用数据缓存功能！')
    } else if (!key) {
        return null
    } else {
        try {
            const data = JSON.parse(localStorage.getItem(key)) || null
            return data
        } catch (error) {
            return localStorage.getItem(key) || null
        }
    }
}
Vue.prototype.$getCacheData = getCacheData
if (getCacheData('firstCache') === null) {
setCacheData('firstCache', 'yes')
}

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js